import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
  // @ts-ignore
  import DatePicker from 'vue2-datepicker'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import UsersApi from '@/services/api/UsersApi'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import { CourseModule } from '@/store/modules/course'
  import useSegment from '@/composables/useSegment'
  import VideoOrImageRenderer from '@/components/course/VideoOrImageRenderer.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { UserModule } from '@/store/modules/user'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExamAppointmentModal',
  props: {
    courseId: {
      type: String,
      default: null,
    },
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()
  const { examAppointmentAdded } = useSegment()
  const { identifyUserInSegmentWithExamDates, setSkipSettingExamAppointment, disableDateBeforeToday } = useCommonMixin()
  const { courseSectionsAssignedCourses } = useCourse()

  const settingAppointment = ref(false)
  const examAppointments = ref<{ courseId: string; date: string }[]>([])

  const loadingData = computed(() => !examCourses.value.length)

  const appointmentsSelected = computed(
    () => examAppointments.value.length > 0 && examAppointments.value.every((appointment) => !!appointment.date),
  )

  const courseBundles = computed(() => CourseModule.courseBundles)

  const bundleJobTitle = computed(() =>
    props.courseId
      ? courseBundles.value?.find((bundle) => bundle.courses.some((course) => course.id === props.courseId))?.jobTitle
      : null,
  )

  const examCourses = computed(() => {
    return (
      courseBundles.value
        ?.flatMap((bundle) =>
          bundle.courses
            .filter((course) => (course.trial || course.purchased) && course.exam)
            .map((course) => ({
              courseId: course.id,
              cardTeaserImageUrl: course.cardTeaserImageUrl || course.teaserImageUrl,
            })),
        )
        .filter((course) => (props.courseId ? course.courseId === props.courseId : true)) || []
    )
  })

  const examAppointmentEntry = computed(
    () => (courseId: string) => examAppointments.value.find((appointment) => appointment.courseId === courseId) ?? null,
  )

  const examAppointment = computed(() => (courseId: string) => examAppointmentEntry.value(courseId)?.date ?? null)

  const transformedDates = computed(() => examAppointments.value.filter((appointment) => !!appointment.date))

  const selectAppointment = (courseId: any, date: any) => {
    const appointmentEntry = examAppointmentEntry.value(courseId)
    if (appointmentEntry) {
      appointmentEntry.date = date
    } else {
      examAppointments.value.push({
        courseId,
        date,
      })
    }
  }

  const clearAppointment = (courseId: any) => {
    const appointmentIndex = examAppointments.value.findIndex((appointment) => appointment.courseId === courseId)
    if (appointmentIndex > -1) {
      examAppointments.value.splice(appointmentIndex, 1)
    }
  }

  const prefillExamDate = () => {
    const appointment = UserModule.examAppointments?.find((appointment) => appointment.courseId === props.courseId)
    if (appointment) {
      CourseModule.setCourseRealExamDate(appointment.date)
    }
  }

  const setAppointment = () => {
    if (!appointmentsSelected.value) {
      eventBus.$emit('close-modal')
      return
    }
    settingAppointment.value = true
    UsersApi.setExamAppointments(transformedDates.value)
      .then(async () => {
        setSkipSettingExamAppointment(false)
        await UserModule.getUser()
        prefillExamDate()
        eventBus.$toasted.success(translateString('examDatePicker.appointmentSetSuccessfully'))
        transformedDates.value.forEach((value) => {
          const course = courseSectionsAssignedCourses.value?.find((c) => c.id === value.courseId)
          if (course) {
            examAppointmentAdded(course.id, course.title, value.date)
            identifyUserInSegmentWithExamDates(course.shortTitle, value.date)
          }
        })
      })
      .finally(() => {
        settingAppointment.value = false
        eventBus.$emit('close-modal')
      })
  }

  const skipSettingExamAppointment = () => {
    setSkipSettingExamAppointment(true)
    eventBus.$emit('close-modal')
  }

  const fetchPackageBundlesAndExamAppointments = async () => {
    if (!CourseModule.courseBundles?.length) await CourseModule.getPackageBundles()

    if (examCourses.value.length !== 0) {
      examAppointments.value =
        UserModule.examAppointments?.map((appointment) => ({
          courseId: appointment.courseId,
          date: appointment.date,
        })) ?? []
    } else {
      eventBus.$emit('close-modal')
    }
  }

  onMounted(() => {
    fetchPackageBundlesAndExamAppointments()
  })

return { __sfc: true,props, translateString, examAppointmentAdded, identifyUserInSegmentWithExamDates, setSkipSettingExamAppointment, disableDateBeforeToday, courseSectionsAssignedCourses, settingAppointment, examAppointments, loadingData, appointmentsSelected, courseBundles, bundleJobTitle, examCourses, examAppointmentEntry, examAppointment, transformedDates, selectAppointment, clearAppointment, prefillExamDate, setAppointment, skipSettingExamAppointment, fetchPackageBundlesAndExamAppointments, computed, onMounted, ref, DatePicker, KetchUpButton, LoadingSpinner, UsersApi, eventBus, useI18n, CourseModule, useSegment, VideoOrImageRenderer, useCommonMixin, UserModule, useCourse }
}

})